/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RbrealityInputs */

const cs_enum_rbreality = /** @type {(inputs: Enum_RbrealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RB Reality`)
};

const en_enum_rbreality = /** @type {(inputs: Enum_RbrealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RB Reality`)
};

/**
* | output |
* | --- |
* | "RB Reality" |
*
* @param {Enum_RbrealityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_rbreality = /** @type {((inputs?: Enum_RbrealityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RbrealityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_rbreality(inputs)
	return cs_enum_rbreality(inputs)
});